import { VDivider } from 'vuetify/lib/components/VDivider';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table',_vm._b({},'table',_vm.$attrs,false),[_c('thead',[_c('tr',[_c('th',[_c('company-letter-head',{staticClass:"pb-5"}),_c(VDivider)],1)])]),_c('tbody',[_vm._m(0),_vm._m(1),_c('tr',[_c('td',[_c('div',{staticStyle:{"height":"20px"}}),_c(VDivider)],1)])]),_vm._m(2)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('td')])
},function (){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('td')])
},function (){var _vm=this,_c=_vm._self._c;return _c('tfoot',[_c('tr',[_c('td')])])
}]

export { render, staticRenderFns }